export default __webpack_public_path__ + "media/images/favicon-39a9917234fdad74b84195d710d08daf.png";